import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import {
  searchJobAdvertisements,
  getJobAdvertisementSearchFilters,
} from 'Features/JobAdvertisement/jobAdvertisementSlice';
import JobAdvertisementResult, {
  JobAdvertisementWithLocIds,
} from 'Components/Jobs/JobSearch/JobAdvertisementResult';
import { RootState } from 'Store';

const Container = styled.div`
  padding: 0 15px 32px;
  @media screen and ${(props) => props.theme.breakpoints.lg} {
    flex: 1;
    min-width: 0;
    padding: 0 0 32px;
  }
  h2 {
    color: #252525;
    font-weight: 100;
    font-family: acumin-pro;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 22px;
    margin: 0 0 10px;
  }
`;

const UserJobAdvertisements = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, loading } = useSelector(
    (state: RootState) => state.jobAdvertisement,
  );
  const { results } = data as any;
  const displayedResults = (results || []).slice(0, 5);

  useEffect(() => {
    dispatch(getJobAdvertisementSearchFilters());
    dispatch(
      searchJobAdvertisements({
        free_text_search: '',
        professional_titles: [],
        employment_types: [],
        organizations: [],
        locations: [],
      }),
    );
  }, [dispatch]);

  return (
    <Container>
      <h2>{t('newest-job-advertisements')}</h2>
      {loading === 'pending' && <p>{t('loading')}...</p>}
      {displayedResults.map((r: JobAdvertisementWithLocIds) => (
        <JobAdvertisementResult result={r} key={r.id} />
      ))}
    </Container>
  );
};

export default UserJobAdvertisements;
